﻿'use-strict'

function Input(el) {
    this._el = el;
    this._type = this._el.type;
    this._button;
    this.init();
}

Input.TYPE = {
    password: 'password',
    text: 'text'
}

Input.BASE = 'sui-AtomInput';
Input.PASSWORD = Input.BASE + '-password';
Input.TOOGLE_BUTTON = Input.PASSWORD + '--toggleButton';
Input.SHOW_BUTTON_STYLE = '-password--toggleButton';

Input.prototype.init = function () {
    if (this._type === Input.TYPE.password) {
        var showButton = document.createElement('span');
        showButton.classList.add(Input.TOOGLE_BUTTON);
        showButton.innerHTML = $.fn.epreselec.defaults.showPassword;
        this._button = showButton;
        this._el.insertAdjacentElement("afterend", this._button);

        var that = this;
        that._button.addEventListener('click', function () {
            that.toogleInputType();
            that.toogleShowHideButton();
        })
    }
}

Input.prototype.toogleInputType = function () {
    if (this._el.type === Input.TYPE.text) {
        this._el.type = Input.TYPE.password;
    } else {
        this._el.type = Input.TYPE.text;
    }
}

Input.prototype.toogleShowHideButton = function () {
    if (this._el.type === Input.TYPE.text) {
        this._button.innerHTML = $.fn.epreselec.defaults.hide;
    } else {
        this._button.innerHTML = $.fn.epreselec.defaults.showPassword;
    }
}

Input.prototype.getValue = function () {
    return this._el.value;
}

window.Input = window.Input || Input